export type VoucherType = {
  id: string
  department: Department
  state: string
  created_at: number
  total_amount: number
  international_payment: boolean
  currency: string
  receivers_account_number: string
  description: string
  reference_number: number
  expense_period?: number | null
  paid_by_amin?: string | number | null
  claimed_by: User
  pay_to: string
  created_by: User
  financial_year: number
  payment_reference: string
  voucher_cost_category: VoucherCostCategory[]
  voucher_approvals: VoucherApproval[]
  workflow?: Workflow | null
  jamat: string
  rejection_reason?: string | null
}

export type Workflow = {
  id: number
  name: string
  active: boolean
  approval_stage: ApprovalStage[]
}

export type VoucherApproval = {
  id: number
  voucher_id: string
  approved_at: string | null
  status: string
  comment: string | null
  order_number: number
  approver: User
  approval_stage: ApprovalStage
}

export type ApprovalStage = {
  id: number
  is_payment_stage: boolean
  order_number: number
}

export type Role = {
  id: number
  name: string
  scope: string
  description: string
}

export type Approver = {
  status: boolean
  user: User
}

export type VoucherCostCategory = {
  id?: number
  cost_category: CostCategory
  cost_share: number
  receipts?: VoucherReceipt[]
}

export type CostCategory = {
  id: string
  name: string
  code: string
  parent_id: string
  parent: CostCategory
}

export type VoucherReceipt = {
  id: string
  path: string
  voucherId?: string
}

export type User = {
  id: string
  first_name: string
  last_name: string
  email: string
  majlis?: string
  user_role?: Role
}

export type Department = {
  id: string
  name: string
}

export enum VoucherApprovalStageStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  PAID = 'PAID',
}

export enum Branch {
  GOTHENBURG = 'GOTHENBURG',
  KALMAR = 'KALMAR',
  LULEA = 'LULEA',
  MALMO = 'MALMO',
  STOCKHOLM = 'STOCKHOLM',
  NATIONAL = 'NATIONAL',
}

export enum VoucherState {
  DRAFT = 'DRAFT',
  SUBMITTED = 'IN_PROGRESS',
  APPROVED = 'APPROVED',
  PAID = 'PAID',
  REJECTED = 'REJECTED',
}

export const Roles = {
  NATIONAL: {
    AMIR: { id: 1, name: 'Amir' },
    AMIN: { id: 3, name: 'Amin' },
    MAAL: { id: 5, name: 'Maal' },
    MISSIONARY: { id: 7, name: 'Missionary' },
    SECRETARY: { id: 9, name: 'Secretary' },
    ADMIN: { id: 11, name: 'Admin' },
    OTHER: { id: 12, name: 'Other' },
  },
  BRANCH: {
    AMIN: { id: 2, name: 'Amin' },
    MAAL: { id: 4, name: 'Maal' },
    MISSIONARY: { id: 6, name: 'Missionary' },
    SADR: { id: 8, name: 'Sadr' },
    SECRETARY: { id: 10, name: 'Secretary' },
  },
} as const
